// extracted by mini-css-extract-plugin
export default {"splitSectionWrapper":"SplitSection_splitSectionWrapper__CyB8t","halfSection":"SplitSection_halfSection__VkVXw"};